/** Bring the opener (main trading tab) to the front. Safe to call from PiP UI. */
export function focusMainWindow(): void {
  try {
    window.focus();
  } catch {
    // Some browsers reject focus() outside a user gesture chain.
  }
}

export const OPEN_NOTIFICATIONS_EVENT = 'perpl:open-notifications';

/** Focus main window and ask the header to open the notifications drawer. */
export function requestOpenNotifications(): void {
  focusMainWindow();
  window.dispatchEvent(new Event(OPEN_NOTIFICATIONS_EVENT));
}
